<script>
  export let embed
</script>

{@html embed}
